import * as Types from '../../../models.gen';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ChapterByIdQueryVariables = Types.Exact<{
  id: Types.Scalars['String'];
}>;


export type ChapterByIdQuery = { chapter: { id: string, name?: string | null, status?: string | null, managementStatus: Array<Types.Chapter_Status>, description?: string | null, luaLink?: string | null, author?: string | null, chapterOrder?: number | null, hasTwoPovs?: boolean | null, updatedAt: any, textLink?: string | null, googleDoc?: { id: string, link?: string | null } | null, googleDoc2Pov?: { id: string, link?: string | null } | null, googleDoc2PovDE?: { id: string, link?: string | null } | null, googleDoc2PovFR?: { id: string, link?: string | null } | null, googleDoc2PovES?: { id: string, link?: string | null } | null, googleDoc2PovNL?: { id: string, link?: string | null } | null, googleDoc2PovPT?: { id: string, link?: string | null } | null, googleDoc2PovIT?: { id: string, link?: string | null } | null, googleDoc2PovPL?: { id: string, link?: string | null } | null, googleDoc2PovSV?: { id: string, link?: string | null } | null, googleDoc2PovDA?: { id: string, link?: string | null } | null, googleDoc2PovNO?: { id: string, link?: string | null } | null, googleDoc2PovFI?: { id: string, link?: string | null } | null, googleDoc2PovID?: { id: string, link?: string | null } | null, googleDoc2PovCS?: { id: string, link?: string | null } | null, googleDoc2PovRO?: { id: string, link?: string | null } | null, googleDoc2PovHU?: { id: string, link?: string | null } | null, googleDoc2PovTR?: { id: string, link?: string | null } | null, googleDoc2PovJA?: { id: string, link?: string | null } | null, googleDoc2PovKO?: { id: string, link?: string | null } | null, googleDoc2PovPT_BR?: { id: string, link?: string | null } | null, googleDocABTest1?: { id: string, link?: string | null, docNotes?: { id: string, name?: string | null } | null } | null, googleDocABTest2?: { id: string, link?: string | null, docNotes?: { id: string, name?: string | null } | null } | null, googleDocABTest3?: { id: string, link?: string | null, docNotes?: { id: string, name?: string | null } | null } | null, googleDocWriter?: { id: string, link?: string | null } | null, googleDocNarrative?: { id: string, link?: string | null } | null, googleDocES?: { id: string, link?: string | null } | null, googleDocFR?: { id: string, link?: string | null } | null, googleDocDE?: { id: string, link?: string | null } | null, googleDocNL?: { id: string, link?: string | null } | null, googleDocPT?: { id: string, link?: string | null } | null, googleDocIT?: { id: string, link?: string | null } | null, googleDocPL?: { id: string, link?: string | null } | null, googleDocSV?: { id: string, link?: string | null } | null, googleDocDA?: { id: string, link?: string | null } | null, googleDocNO?: { id: string, link?: string | null } | null, googleDocFI?: { id: string, link?: string | null } | null, googleDocID?: { id: string, link?: string | null } | null, googleDocCS?: { id: string, link?: string | null } | null, googleDocRO?: { id: string, link?: string | null } | null, googleDocHU?: { id: string, link?: string | null } | null, googleDocTR?: { id: string, link?: string | null } | null, googleDocJA?: { id: string, link?: string | null } | null, googleDocKO?: { id: string, link?: string | null } | null, googleDocPT_BR?: { id: string, link?: string | null } | null, additionalDocs?: Array<{ id: string, docOrder?: number | null, docNotes?: { id: string, name?: string | null } | null }> | null, items: Array<{ name?: string | null }>, backgrounds: Array<{ id: string, name?: string | null, link?: string | null }>, heroes: Array<{ names: Array<string>, clothes: Array<{ name?: string | null }>, hairs: Array<{ name?: string | null }>, bodies?: Array<{ name?: string | null }> | null, layers: Array<{ name?: string | null }> }> } };


export const ChapterByIdDocument = gql`
    query ChapterById($id: String!) {
  chapter(id: $id) {
    id
    name
    status
    managementStatus
    description
    luaLink
    author
    chapterOrder
    hasTwoPovs
    googleDoc {
      id
      link
    }
    googleDoc2Pov {
      id
      link
    }
    googleDoc2PovDE {
      id
      link
    }
    googleDoc2PovFR {
      id
      link
    }
    googleDoc2PovES {
      id
      link
    }
    googleDoc2PovNL {
      id
      link
    }
    googleDoc2PovPT {
      id
      link
    }
    googleDoc2PovIT {
      id
      link
    }
    googleDoc2PovPL {
      id
      link
    }
    googleDoc2PovSV {
      id
      link
    }
    googleDoc2PovDA {
      id
      link
    }
    googleDoc2PovNO {
      id
      link
    }
    googleDoc2PovFI {
      id
      link
    }
    googleDoc2PovID {
      id
      link
    }
    googleDoc2PovCS {
      id
      link
    }
    googleDoc2PovRO {
      id
      link
    }
    googleDoc2PovHU {
      id
      link
    }
    googleDoc2PovTR {
      id
      link
    }
    googleDoc2PovJA {
      id
      link
    }
    googleDoc2PovKO {
      id
      link
    }
    googleDoc2PovPT_BR {
      id
      link
    }
    googleDocABTest1 {
      id
      link
      docNotes {
        id
        name
      }
    }
    googleDocABTest2 {
      id
      link
      docNotes {
        id
        name
      }
    }
    googleDocABTest3 {
      id
      link
      docNotes {
        id
        name
      }
    }
    googleDocWriter {
      id
      link
    }
    googleDocNarrative {
      id
      link
    }
    googleDocES {
      id
      link
    }
    googleDocFR {
      id
      link
    }
    googleDocDE {
      id
      link
    }
    googleDocNL {
      id
      link
    }
    googleDocPT {
      id
      link
    }
    googleDocIT {
      id
      link
    }
    googleDocPL {
      id
      link
    }
    googleDocSV {
      id
      link
    }
    googleDocDA {
      id
      link
    }
    googleDocNO {
      id
      link
    }
    googleDocFI {
      id
      link
    }
    googleDocID {
      id
      link
    }
    googleDocCS {
      id
      link
    }
    googleDocRO {
      id
      link
    }
    googleDocHU {
      id
      link
    }
    googleDocTR {
      id
      link
    }
    googleDocJA {
      id
      link
    }
    googleDocKO {
      id
      link
    }
    googleDocPT_BR {
      id
      link
    }
    additionalDocs {
      id
      docOrder
      docNotes {
        id
        name
      }
    }
    items {
      name
    }
    backgrounds {
      id
      name
      link
    }
    heroes {
      names
      clothes {
        name
      }
      hairs {
        name
      }
      bodies {
        name
      }
      layers {
        name
      }
    }
    updatedAt
    textLink
  }
}
    `;

/**
 * __useChapterByIdQuery__
 *
 * To run a query within a React component, call `useChapterByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useChapterByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChapterByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useChapterByIdQuery(baseOptions: Apollo.QueryHookOptions<ChapterByIdQuery, ChapterByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChapterByIdQuery, ChapterByIdQueryVariables>(ChapterByIdDocument, options);
      }
export function useChapterByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChapterByIdQuery, ChapterByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChapterByIdQuery, ChapterByIdQueryVariables>(ChapterByIdDocument, options);
        }
export type ChapterByIdQueryHookResult = ReturnType<typeof useChapterByIdQuery>;
export type ChapterByIdLazyQueryHookResult = ReturnType<typeof useChapterByIdLazyQuery>;
export type ChapterByIdQueryResult = Apollo.QueryResult<ChapterByIdQuery, ChapterByIdQueryVariables>;